<template>
  <div class="input-prioritize">
    <draggable
      v-if="innerChoices.length"
      v-model="innerChoices"
      item-key="value"

      tag="transition-group"
      :component-data="componentData"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
    >
      <template #item="{ element, index }">
        <input-button
          v-if="element"
          class="td-400"
          :class="index === 0 ? '' : 'mt-2'"
          :state="index !== element.originalIndex ? 'active' : 'active'"
        >
          <markdown-text>{{ getElementLabel(element) }}</markdown-text>
        </input-button>
      </template>
    </draggable>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import draggable from 'vuedraggable';
import extend from 'extend';

import { compareArrays } from '@/utils/arrayUtil';
import InputComponent from '../InputComponent';
import InputButton from '../common/InputButton/InputButton';
import MarkdownText from '../../common/MarkdownText';

export default {
  name: 'InputPriority',
  components: { MarkdownText, InputButton, draggable },
  extends: InputComponent,
  props: {
    modelValue: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    choices: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      innerValue: [],
      innerChoices: [],
      validValues: [],
      drag: false,
      dragImage: null,

      innerChoicesListenUpdates: false,
    };
  },
  computed: {
    componentData() {
      return {
        tag: 'ul',
        type: 'transition-group',
        name: !this.drag ? 'flip-list' : null,
      };
    },
    dragOptions() {
      return {
        animation: 400,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  watch: {
    choices: {
      handler() {
        this.updateChoices();
      },
      deep: true,
    },
    modelValue: {
      handler() {
        const newInnerValue = compareArrays(this.modelValue, this.innerValue);

        if (newInnerValue === true) {
          // It's already the same values
          return;
        }

        this.setInnerValue(this.modelValue);
      },
      deep: true,
    },
    innerValue: {
      handler() {
        const newValue = compareArrays(this.innerValue, this.modelValue);

        if (newValue === true) {
          // It's already the same values
          return;
        }

        console.log('update:modelValue', {
          newValue,
          innerValue: this.innerValue,
          modelValue: this.modelValue,
        });

        this.$emit('update:modelValue', newValue);
      },
      deep: true,
    },
    innerChoices: {
      handler() {
        if (!this.innerChoicesListenUpdates) {
          return;
        }

        const innerValue = [];

        for (const choice of this.innerChoices) {
          innerValue.push(choice.value);
        }

        this.innerValue = innerValue;

        console.log('innerChoicesChanged', this.innerChoices, innerValue);
      },
    },
  },
  mounted() {
    this.updateChoices();

    document.addEventListener('dragstart', this.onDragStart, false);

    const dragImage = new Image();

    // Empty image
    dragImage.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';

    this.dragImage = dragImage;
  },
  unmounted() {
    document.removeEventListener('dragstart', this.onDragStart, false);
  },
  computed: {
    ...mapState(useSurveyStore, ['showQuestionAnswerIds']),
  },
  methods: {
    getElementLabel(element) {
      if (this.showQuestionAnswerIds) {
        return `${element.value} - ${element.label}`;
      }

      return element.label;
    },
    updateChoices() {
      console.log('MOUNTED!!!');
      this.setInnerChoicesFromChoices();

      if (this.modelValue && this.modelValue.length) {
        this.setInnerValue(this.modelValue);
      }
    },
    onDragStart(e) {
      e.dataTransfer.setDragImage(this.dragImage, 0, 0);
    },
    setInnerValue(newInnerValue) {
      console.log('settingInnerValue to newInnerValue', this.innerValue, newInnerValue);

      this.innerValue = newInnerValue;

      const assocChoices = {};
      let choiceIndex = 0;

      for (const choice of this.choices) {
        const newChoice = extend({}, choice);

        newChoice.index = choiceIndex;

        assocChoices[choice.value] = choice;

        choiceIndex += 1;
      }

      const innerChoices = [];

      for (const value of newInnerValue) {
        innerChoices.push(assocChoices[value]);
      }

      console.log('setInnerValue.setInnerChoices', {
        innerValue: this.innerValue,
        assocChoices,
        innerChoices,
      });

      this.innerChoicesListenUpdates = false;

      this.innerChoices = innerChoices;

      this.$nextTick(() => {
        this.innerChoicesListenUpdates = true;
      });
    },
    setInnerChoicesFromChoices() {
      const innerChoices = this.choices && this.choices.length ? this.choices : [];

      let index = 0;

      for (const innerChoice of innerChoices) {
        innerChoice.originalIndex = index;

        index += 1;
      }

      console.log('setInnerChoicesFromChoices', {
        choices: this.choices,
        innerChoices,
      });

      this.innerChoicesListenUpdates = false;

      this.innerChoices = innerChoices;

      this.$nextTick(() => {
        this.innerChoicesListenUpdates = true;
      });
    },
    /* setChoiceValuesFromInnerChoices() {
      const choiceValues = [];

      for (const choice of this.innerChoices) {
        choiceValues.push(choice.value);
      }

      console.log('set innerValue from innerChoices', choiceValues);
      this.innerValue = choiceValues;
    }, */
  },
};

</script>

<style lang="scss" scoped>
.input-prioritize {
  padding-right: 30px;
}
.input-button {
  transition-timing-function: ease-out;
  //transition-duration: 400ms;
  transition-property: background-color, margin-left;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ghost {
  opacity: 1;
  background-color: #6AB8DA !important;
  margin-left: 30px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
}

.input-button {
  cursor: move;
}

.flip-list-move {
  transition: transform 400ms;
}

.no-move {
  transition: transform 0s;
}
</style>
